import React from "react";
import IconifyIcon from "../IconifyIcon";
import { Button } from "@mui/material";
import PhotoModal from "../Modals/PhotoModal";

interface PhotoButtonProps {
  photoType: "id" | "plates" | "visitor" | "other";
  file: File | null;
  setFile: (file: File | null) => void;
}

const PhotoButton = ({ photoType, file, setFile }: PhotoButtonProps) => {
  const [showModal, setShowModal] = React.useState<boolean>(false);

  return (
    <div>
      <PhotoModal
        showModal={showModal}
        setShowModal={setShowModal}
        photoType={photoType}
        setFile={setFile}
      />
      {photoType === "id" && (
        <Button
          variant={file ? "outlined" : "contained"}
          onClick={() => setShowModal(true)}
          startIcon={
            file ? <IconifyIcon icon={"material-symbols:check-rounded"} /> : ""
          }
        >
          <IconifyIcon icon={"fa-regular:id-card"} style={{ fontSize: 20 }} />
        </Button>
      )}
      {photoType === "plates" && (
        <Button
          variant={file ? "outlined" : "contained"}
          onClick={() => setShowModal(true)}
          startIcon={
            file ? <IconifyIcon icon={"material-symbols:check-rounded"} /> : ""
          }
        >
          <IconifyIcon icon={"fa-solid:car-alt"} style={{ fontSize: 20 }} />
        </Button>
      )}
      {photoType === "visitor" && (
        <Button
          variant={file ? "outlined" : "contained"}
          onClick={() => setShowModal(true)}
          startIcon={
            file ? <IconifyIcon icon={"material-symbols:check-rounded"} /> : ""
          }
        >
          <IconifyIcon icon={"fa-solid:user"} style={{ fontSize: 20 }} />
        </Button>
      )}
      {photoType === "other" && (
        <Button
          variant={file ? "outlined" : "contained"}
          onClick={() => setShowModal(true)}
          startIcon={
            file ? <IconifyIcon icon={"material-symbols:check-rounded"} /> : ""
          }
        >
          <IconifyIcon icon={"fa-solid:laptop"} style={{ fontSize: 20 }} />
        </Button>
      )}
    </div>
  );
};

export default PhotoButton;
